import { z } from 'zod';

import { paymentIdSchema, refundIdSchema } from './ids';

export const BILLING_HISTORY_ENTRY_TYPES = [
    'PAYMENT_RECORDED',
    'PAYMENT_APPLIED',
    'REFUND_ISSUED',
    'SERVICE_CHANGED',
    'FEE_CHANGED',
] as const;

const billingHistoryEntryBaseFields = {
    id: z.uuid(),
    occurredAt: z.iso.datetime(),
    performedByName: z.string(),
};

export const billingHistoryEntrySchema = z.discriminatedUnion('type', [
    z.object({
        ...billingHistoryEntryBaseFields,
        type: z.literal('PAYMENT_RECORDED'),
        paymentId: paymentIdSchema,
        sessionCount: z.number().int().min(1),
    }),
    z.object({
        ...billingHistoryEntryBaseFields,
        type: z.literal('PAYMENT_APPLIED'),
        paymentId: paymentIdSchema,
        amountCents: z.number().int().min(1),
    }),
    z.object({
        ...billingHistoryEntryBaseFields,
        type: z.literal('REFUND_ISSUED'),
        refundId: refundIdSchema,
        amountCents: z.number().int().min(1).nullable(),
    }),
    z.object({
        ...billingHistoryEntryBaseFields,
        type: z.literal('SERVICE_CHANGED'),
        fromCode: z.string(),
        toCode: z.string(),
    }),
    z.object({
        ...billingHistoryEntryBaseFields,
        type: z.literal('FEE_CHANGED'),
        fromCents: z.number().int().min(0),
        toCents: z.number().int().min(0),
    }),
]);

export type BillingHistoryEntry = z.infer<typeof billingHistoryEntrySchema>;
